import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';

export function* initUpnpSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  yield put(actions.initUpnpStart());
  try {
    let response = {};
    const token = yield sessionStorage.getItem('token');
    const sessionToken = yield sessionStorage.getItem('sessionToken');
    if (sessionToken) {
      response = yield axios.post(
        '/upnp',
        {
          rMac: rMac || '',
          bToken: token,
          sessionToken:sessionToken
        }
      ).then(res => {
        return JSON.parse(res.data.upnp)

      })


    } else {
      //console.log('NO TOKEN')
    }
    yield put(actions.setUpnp(response));
  } catch (error) {
    yield put(actions.fetchUpnpFailed());
  }

}
export function* changeUpnpSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  let eventName;
  let eventType;
  if(action.enabled){
    eventName = 'UPNP - Toggle ON';
    eventType = 'UPnP Enabled';
  }else{
    eventName = 'UPNP - Toggle OFF';
    eventType = 'UPnP Disabled';
  }

  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const techMobile = yield sessionStorage.getItem('techMobile');
  const browser = techMobile === 'true' ? 'TECH_MOBILE' : 'WEB_CLIENT';

    if (sessionToken) {
    try {
      const response = yield axios.put(
        '/upnpChange',
        {
          rMac: rMac || '',
          bToken: token,
          mode: action.enabled ? 'enable' : 'disable',
          accountNumber: accountNumber,
          eventName: eventName,
          eventType: eventType,
          divId: divId,
          user: user,
          browser,
          sessionToken:sessionToken
        }
      )
      if(response.status === 202){
      const upnpResponse = yield axios.post('/upnp', {
        rMac: rMac || '',
        bToken: token,
        sessionToken: sessionToken
      }).then(res => JSON.parse(res.data.upnp)).catch(() => null);
      if(upnpResponse) {
        upnpResponse.enabled = action.enabled;
        yield put(actions.setUpnp(upnpResponse));
      }
      yield put(actions.changeUpnpSuccess());
      }else{
        //console.log('FAILED UPNP')
        yield put(actions.changeUpnpFailed());
      }



    } catch (error) {
      console.error('FAILED UPNP')
      yield put(actions.changeUpnpFailed());
    }
  } else {
    //console.log('NO TOKEN')
    yield put(actions.changeUpnpFailed());

  }

}

